import React, { useEffect } from 'react'
import Search from '../components/Search'

const HomePage: React.FC = () => {

    return (
        <Search />
    )
}

export default HomePage